module.exports = __webpack_public_path__ + "static/img/strawberrysunset_th.a4b9aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/strawberrysunset_th.png
// module id = Da+M
// module chunks = 0